<div class="modal-header">
  <h4 class="modal-title pull-left"> {{ isEdit ? 'Edit Privilege': 'New Privilege' }} </h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span></div>
</div>

<div class="modal-body">
  <form name="form" #f="ngForm" (ngSubmit)="f.form.valid && onSubmit()" novalidate>
    <div class="form-group">
      <label class="rbv-label">Name</label>
      <input type="text" maxlength="60" name="NAME" [(ngModel)]="privilege.NAME" #NAME="ngModel" class="form-control rounded-0 rbv-field"
        [ngClass]="{ 'is-invalid': f.submitted && NAME.invalid }" required>
      <div *ngIf="f.submitted && NAME.invalid" class="invalid-feedback">
        <div *ngIf="NAME.errors.required">Name is required</div>
      </div>
    </div>

    <div class="form-group">
      <label class="rbv-label">Code</label>
      <input #input (keypress)="onKeyPress($event)" maxlength="30" type="text" name="CODE" [(ngModel)]="privilege.CODE" (ngModelChange)="privilege.CODE = $event.toUpperCase()" 
        #CODE="ngModel" class="form-control rounded-0 rbv-field" [ngClass]="{ 'is-invalid': f.submitted && CODE.invalid }" required>
      <div *ngIf="f.submitted && CODE.invalid" class="invalid-feedback">
        <div *ngIf="CODE.errors.required">Code is required</div>
      </div>
    </div>

    <div class="form-group">
      <label class="rbv-label">Description</label>
      <textarea type="text" maxlength="250" name="DESC" [(ngModel)]="privilege.DESC" #DESC="ngModel" class="form-control rounded-0 rbv-field" style="height: 150px;"></textarea>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
  <button [disabled]="!f.form.valid" type="button" class="btn btn-rbv" (click)="onSubmit()"> {{ isEdit ? 'Save': 'Create' }} </button>
</div>
